import { useApp } from '@/context/app';

export interface CartModeConfig {
	isPurchaseOrder: boolean;

	// Carrinho / Pedido
	cartTitle: string;
	addButton: string;
	finalizeButton: string;
	drawerTitle: string;
	emptyMessage: string;
	clearButton: string;
	toastAdded: string;
	toastRemoved: string;
	removeDialogContext: string;

	// Estados do produto (Product.tsx)
	readyTitle: string;
	readyOBS: string;
	idleTitle: string;
	idleOBS: string;
	disconnectedOBS: string;
}

export function useCartMode(): CartModeConfig {
	const { connection } = useApp();
	const isPurchaseOrder = Boolean(
		connection.functions?.includes('purchase_order'),
	);

	if (isPurchaseOrder) {
		return {
			isPurchaseOrder,
			cartTitle: 'Pedido de Compra',
			addButton: 'Adicionar ao Pedido',
			finalizeButton: 'Gerar Pedido',
			drawerTitle: 'Adicionar ao Pedido',
			emptyMessage: 'Nenhum produto no pedido',
			clearButton: 'Limpar Pedido',
			toastAdded: 'Produto adicionado ao pedido!',
			toastRemoved: 'Item removido do pedido',
			removeDialogContext: 'do pedido',
			readyTitle: 'PEDIDO DE COMPRA',
			readyOBS: 'Escaneie um produto para montar seu pedido',
			idleTitle: 'ADICIONE AO PEDIDO',
			idleOBS: 'Escaneie o produto para adicionar',
			disconnectedOBS: 'Pedido de Compra desconectado. Tente novamente!',
		};
	}

	return {
		isPurchaseOrder,
		cartTitle: 'Consulta Preço',
		addButton: 'Adicionar ao Carrinho',
		finalizeButton: 'Finalizar Compra',
		drawerTitle: 'Adicionar ao Carrinho',
		emptyMessage: 'Seu carrinho está vazio',
		clearButton: 'Limpar Carrinho',
		toastAdded: 'Produto adicionado ao carrinho!',
		toastRemoved: 'Item removido',
		removeDialogContext: 'do carrinho',
		readyTitle: 'PRONTO PARA INICIAR',
		readyOBS: 'Faça sua primeira consulta agora!',
		idleTitle: 'CONSULTE O PREÇO AGORA MESMO',
		idleOBS: 'Leia o código de barras',
		disconnectedOBS: 'Consulta Preço desconectado. Tente novamente!',
	};
}
